import { useI18n, SUPPORTED_LANGS } from '../i18n';

export default function LanguageSwitcher({ className = '', variant = 'outline-light' }) {
  const { lang, setLang, t } = useI18n();
  return (
    <div className={`btn-group btn-group-sm ${className}`} role="group" aria-label={t('lang.label')}>
      {SUPPORTED_LANGS.map((code) => (
        <button
          key={code}
          type="button"
          className={`btn btn-${variant}${lang === code ? ' active' : ''}`}
          aria-pressed={lang === code}
          title={t(`lang.${code}`)}
          onClick={() => setLang(code)}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
